import { render, staticRenderFns } from "./AdditionalSaleCard.vue?vue&type=template&id=1db09c4b&scoped=true"
import script from "./AdditionalSaleCard.vue?vue&type=script&lang=js"
export * from "./AdditionalSaleCard.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSaleCard.vue?vue&type=style&index=0&id=1db09c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db09c4b",
  null
  
)

export default component.exports